import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button, Form, FormGroup } from 'reactstrap';
import i18n from '@/utils/i18n';
import Checkbox from '../../../components/Checkbox';
import {
  CheckBoxLabel,
  CheckBoxLabelContainer,
} from '../../../components/Checkbox/pickpackCheckbox';

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (sendDeletionEvent: boolean) => void;
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [sendDeletionEvent, setSendDeletionEvent] = useState(false);

  const handleConfirm = () => {
    onConfirm(sendDeletionEvent);
    onClose();
  };

  const footer = (
    <div>
      <Button onClick={handleConfirm} color="danger">
        Delete User
      </Button>
      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>
    </div>
  );

  return (
    <Dialog
      header="Delete User"
      visible={isOpen}
      onHide={onClose}
      style={{ minWidth: '50vw' }}
      footer={footer}
    >
      <Form>
        <FormGroup>
          <CheckBoxLabelContainer
            style={{ marginTop: '1.5em' }}
            onClick={() => setSendDeletionEvent(!sendDeletionEvent)}
          >
            <Checkbox checked={sendDeletionEvent} />
            <CheckBoxLabel>
              {i18n.t('Users:deleteUserConfirmation')}
            </CheckBoxLabel>
          </CheckBoxLabelContainer>
          <p>
            <b>
              Are you sure that you want to delete this user? THIS ACTION CANNOT
              BE UNDONE!
            </b>
          </p>
        </FormGroup>
      </Form>
    </Dialog>
  );
};
